const Loader=()=>(
  <div className="w-100 flex justify-center">
    <i className="icon-loading loader text-50"/>
  </div>
)

export default Loader;
